// Analítica ligera (GA4 + Google Ads). No hace nada si no hay IDs configurados
// en el build (REACT_APP_GA_ID / REACT_APP_ADS_ID). La carga del script gtag
// se hace en public/index.html; aquí solo disparamos eventos/conversiones.

function gtag() {
  return typeof window !== "undefined" && typeof window.gtag === "function" ? window.gtag : null;
}

function val(name) {
  if (typeof window === "undefined") return "";
  const v = window[name];
  return v && v.indexOf("%") !== 0 && v.length > 3 ? v : "";
}

// Conversión de registro (alta de una cuenta nueva)
export function trackSignup() {
  const g = gtag();
  if (!g) return;
  g("event", "sign_up", { method: "email" }); // GA4
  const ads = val("__ADS_ID__");
  const label = val("__ADS_SIGNUP_LABEL__");
  if (ads && label) g("event", "conversion", { send_to: `${ads}/${label}` }); // Google Ads
}

// Conversión de LEAD (solicitud del servicio gestionado) — la más importante
// para los Ads: es un cliente potencial capturado.
export function trackLead() {
  const g = gtag();
  if (!g) return;
  g("event", "generate_lead", { method: "form" }); // GA4
  const ads = val("__ADS_ID__");
  const label = val("__ADS_LEAD_LABEL__");
  if (ads && label) g("event", "conversion", { send_to: `${ads}/${label}` }); // Google Ads
}

// Conversión de pago (suscripción contratada)
export function trackPurchase(plan) {
  const g = gtag();
  if (!g) return;
  g("event", "purchase", { items: [{ item_name: plan || "plan" }] }); // GA4
  const ads = val("__ADS_ID__");
  const label = val("__ADS_PURCHASE_LABEL__");
  if (ads && label) g("event", "conversion", { send_to: `${ads}/${label}` }); // Google Ads
}
